

import React from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";

import useRootStore from "../../store/useRootStore";
import { BookActionItem } from "./BookActionItem";

import {
  BookIcon,
  UploadIcon,
  BoxsetIcon,
} from "../../content/icons";

import { UploadBookForm, NewBookModal, NewBoxsetModal } from "./forms";
import { useOnlineStatus } from "../../utils/hooks/isOffline";
import { ShelfWSMessageData } from "../../types/common";
import { BOOKSHELF_BOOK_ADDED, wsSendShelfUpdateMessage } from "../../utils/bookshelf-ws-helper";


export const BookActionSection : React.FC = observer(({ children}) => {
  const { 
    newBookModal, 
    newBoxsetModal, 
    uploadBookModal, 
    setModal,
    onUpload,
    newBook,
    newBoxset 
  } = useRootStore().shelfStore;
  const { user } = useRootStore().authStore;
  const { resetState } = useRootStore().bookStore;
  const { appIdle } = useRootStore().appStore;
  const { socket } = useRootStore().bookSyncWebSocketStore;
  const { push } = useHistory();
  const isOnline = useOnlineStatus();

  const navigateToBook = (bookId: string, chapterId?: string) => {
    resetState();
    push(chapterId ? `/books/${bookId}/${chapterId}` : `/books/${bookId}`);
  };

  return (
    <>
      <div className="book-action-section inner-m">
        <div className="book-action-section-left">
          <BookActionItem 
            isDisabled={!(appIdle && isOnline)}
            icon={<UploadIcon color="#fff" />}
            onClick={() => setModal("uploadBookModal", true)}
            label="Upload a book"
          />
          <BookActionItem
            isDisabled={!appIdle}
            icon={<BookIcon color="#fff" />}
            onClick={() => setModal("newBookModal", true)}
            label="Start a new book"
          />

          <BookActionItem 
            isDisabled={!appIdle}
            icon={<BoxsetIcon color="#fff" />}
            onClick={() => setModal("newBoxsetModal", true)}
            label="Create a new boxset"
          />
        </div>
        {children}
      </div>     
      <UploadBookForm
        showModal={uploadBookModal}
        onUpload={async (params) => {
          const bookId = await onUpload(params);
          if (user) {
						const data: ShelfWSMessageData = {
              userId: user._id,
              bookId: bookId,
              isCollabBook: false,
						};
						wsSendShelfUpdateMessage(socket, BOOKSHELF_BOOK_ADDED, data);
					}
          setModal("uploadBookModal", false);
          if(bookId){
            navigateToBook(bookId);
          }
        }} 
        onClose={() => setModal("uploadBookModal", false)}
      />
      <NewBookModal  
        showModal={newBookModal}  
        onNewBook={async (params) => {
          await newBook(params);
          if (user) {
            const data: ShelfWSMessageData = {
              userId: user._id,
              bookId: params._id,
              isCollabBook: false,
            };
            wsSendShelfUpdateMessage(socket, BOOKSHELF_BOOK_ADDED, data);
          }
          setModal("newBookModal", false);
          navigateToBook(params._id, params.chapterId);
        }}        
        onClose={() => setModal("newBookModal", false)}
      />
      <NewBoxsetModal 
        showModal={newBoxsetModal}  
        onNewBoxset={async (params) => {
          const bookId = await newBoxset(params);
          if (user) {
            const data: ShelfWSMessageData = {
              userId: user._id,
              bookId: bookId,
              isCollabBook: false,
            };
            wsSendShelfUpdateMessage(socket, BOOKSHELF_BOOK_ADDED, data);
          }
          setModal("newBoxsetModal", false);
          navigateToBook(bookId);
        }}
        onClose={() => setModal("newBoxsetModal", false)}
      />
    </>
  );
});
